<template>
  <div class="padding-zero">
    <user-process-nav :current="'TASKS'" />
    <button
      class="btn btn-sm btn-outline-dark addNewTaskButton"
      data-toggle="modal"
      data-target="#addNewTask"
    >
      Dodaj nowe zadanie
    </button>

    <div class="tasks">
      <!-- MENU -->

      <div class="left-panel">
        <div class="filterButtons">
          <form @submit.prevent="searchWithParam()">
            <div class="inner-addon left-addon">
              <input
                type="text"
                placeholder="Wyszukiwanie.."
                style="border-radius: 10px"
                class="form-control"
                v-model="filter_param"
              />
            </div>
          </form>
        </div>
        <div class="filterButtons">
          <button
            class="btn btn-sm"
            @click="showOldTasks"
            :class="{ selectedButton: selectedDate === 'Przeterminowane' }"
          >
            Przeterminowane
          </button>
          <button
            class="btn btn-sm"
            :class="{ selectedButton: selectedDate === 'Dzisiejsze' }"
            @click="showTodayTasks"
          >
            Dzisiejsze
          </button>
          <button
            class="btn btn-sm"
            @click="showFutureTasks"
            :class="{ selectedButton: selectedDate === 'Nadchodzące' }"
          >
            Nadchodzące
          </button>
          <button
            class="btn btn-sm"
            @click="showFinishedTasks"
            :class="{ selectedButton: selectedDate === 'Zakończone' }"
          >
            Zakończone
          </button>
        </div>

        <div class="filterButtons">
          <button
            class="btn btn-sm"
            @click="showOwnTasks"
            :class="{ selectedButton: own }"
          >
            Przypisane do mnie
          </button>
          <button
            class="btn btn-sm"
            @click="showAllTasks"
            :class="{ selectedButton: !own }"
          >
            Wszystkie
          </button>

          <p class="mt-4">Przypisane do konkretnego administratora</p>
          <select
            v-model="selectedAssignedAdmin"
            @change="showTaskAssignedToAdmin"
          >
            <option :value="selectedAssignedAdmin" selected>
              {{ selectedAssignedAdmin.phone }}
            </option>
            <option :value="'Brak'">
              Brak
            </option>
            <option
              :value="admin.phone"
              v-for="admin in allAdmins"
              :key="admin.id"
            >
              {{ admin.phone }}
            </option>
          </select>
        </div>

        <div class="filterButtons">
          <button
            class="btn btn-sm"
            @click="showPriorityOne"
            :class="{ selectedButton: priority === 'ONE' }"
          >
            Priorytet najwyższy
          </button>
          <button
            class="btn btn-sm"
            @click="showPriorityTwo"
            :class="{ selectedButton: priority === 'TWO' }"
          >
            Priorytet wysoki
          </button>
          <button
            class="btn btn-sm"
            @click="showPriorityThree"
            :class="{ selectedButton: priority === 'THREE' }"
          >
            Priorytet niski
          </button>
          <button
            class="btn btn-sm"
            @click="showPriorityFour"
            :class="{ selectedButton: priority === 'FOUR' }"
          >
            Priorytet najniższy
          </button>
          <button
            class="btn btn-sm"
            @click="showAllPriorities"
            :class="{ selectedButton: priority === null }"
          >
            Wszystkie
          </button>
        </div>

        <div class="filterButtons">
          <button
            class="btn btn-sm"
            @click="showVerificationTasks"
            :class="{ selectedButton: category === 'VERIFICATION' }"
          >
            Weryfikacja
          </button>
          <button
            class="btn btn-sm"
            @click="showRodoTasks"
            :class="{ selectedButton: category === 'RODO' }"
          >
            Rodo
          </button>
          <button
            class="btn btn-sm"
            @click="showDeletedAccountTasks"
            :class="{ selectedButton: category === 'DELETED_ACCOUNT' }"
          >
            Usunięcie konta
          </button>
          <button
            class="btn btn-sm"
            @click="showStolenAccountTasks"
            :class="{ selectedButton: category === 'STEALING' }"
          >
            Kradzież konta
          </button>
          <button
            class="btn btn-sm"
            @click="showDeathTasks"
            :class="{ selectedButton: category === 'DEATH' }"
          >
            Śmierć
          </button>
          <button
            class="btn btn-sm"
            @click="showPaymentTasks"
            :class="{ selectedButton: category === 'PAYMENT' }"
          >
            Płatność
          </button>
          <button
            class="btn btn-sm"
            @click="showProfileTasks"
            :class="{ selectedButton: category === 'PROFILE' }"
          >
            Profil
          </button>
          <button
            class="btn btn-sm"
            @click="showServiceTasks"
            :class="{ selectedButton: category === 'SERVICE' }"
          >
            Usługa
          </button>
          <button
            class="btn btn-sm"
            @click="showAllCategories"
            :class="{ selectedButton: category === null }"
          >
            Wszystkie
          </button>
        </div>
      </div>

      <div class="main-content">
        <!-- ACTIVE -->
        <div v-if="type === 'active'">
          <div class="tasksList">
            <!-- TODO -->
            <div class="todoTasks todoContainer" v-if="todoTasks">
              <p class="type">
                Do zrobienia ({{ todoTasks.total ? todoTasks.total : 0 }})
              </p>
              <div class="pagination">
                <i
                  @click="
                    previousPage(
                      todoTasks.page_number,
                      todoTasks.on_page,
                      'fetchTodoTasks'
                    )
                  "
                  v-if="todoTasks.page_number > 1"
                  class="fas fa-arrow-circle-left"
                ></i>
                <i v-else class="fas fa-arrow-circle-left disabled-icon"></i>

                <i
                  @click="
                    nextPage(
                      todoTasks.page_number,
                      todoTasks.on_page,
                      'fetchTodoTasks'
                    )
                  "
                  v-if="
                    calcPage(
                      todoTasks.page_number,
                      todoTasks.on_page,
                      todoTasks.total
                    )
                  "
                  class="fas fa-arrow-circle-right"
                ></i>
                <i v-else class="fas fa-arrow-circle-right disabled-icon"></i>
              </div>
              <draggable
                style="height: 90%; overflow: auto"
                v-model="todoTasksArray"
                group="tasks"
                @start="drag = true"
                @end="drag = false"
                @change="saveTodoTasks('TODO')"
              >
                <div
                  class="task"
                  v-for="task in todoTasksArray"
                  :key="task.id"
                  data-toggle="modal"
                  :data-target="`#task`"
                  @click="setTask(task)"
                >
                  <div class="taskTitle">{{ task.title }}</div>
                  <div class="taskNoteUser" v-if="task.profile_note_user">
                    {{ task.profile_note_user.phone }}
                  </div>
                  <div class="taskPriority">
                    {{
                      task.priority && task.priority === "ONE"
                        ? "Priorytet najwyższy"
                        : ""
                    }}
                  </div>
                  <div class="taskPriority">
                    {{
                      task.priority && task.priority === "TWO"
                        ? "Priorytet wysoki"
                        : ""
                    }}
                  </div>
                  <div class="taskPriority">
                    {{
                      task.priority && task.priority === "THREE"
                        ? "Priorytet niski"
                        : ""
                    }}
                  </div>
                  <div class="taskPriority">
                    {{
                      task.priority && task.priority === "FOUR"
                        ? "Priorytet najniższy"
                        : ""
                    }}
                  </div>

                  <span class="taskCategory">
                    <span v-if="task.messages.length > 0">
                      <span
                        v-if="task.category === 'STEALING'"
                        style="margin-right: 5px"
                        >Kradzież</span
                      >
                      <span
                        v-if="task.category === 'DEATH'"
                        style="margin-right: 5px"
                        >Śmierć</span
                      >
                      <span
                        v-if="task.category === 'PAYMENT'"
                        style="margin-right: 5px"
                        >Płatność</span
                      >
                      <span
                        v-if="task.category === 'RODO'"
                        style="margin-right: 5px"
                        >Rodo</span
                      >
                      <span
                        v-if="task.category === 'PROFILE'"
                        style="margin-right: 5px"
                        >Profil</span
                      >
                      <span
                        v-if="task.category === 'SERVICE'"
                        style="margin-right: 5px"
                        >Usługa</span
                      >
                      <span
                        v-if="task.category === 'VERIFICATION'"
                        style="margin-right: 5px"
                        >Weryfikacja</span
                      >
                      <span
                        v-if="task.category === 'DELETED_ACCOUNT'"
                        style="margin-right: 5px"
                        >Usunięcie konta</span
                      >
                      <i
                        class="far fa-comment"
                        :class="{ unreadMessage: task.last_message_unread }"
                      ></i
                      >{{ task.messages.length }}</span
                    >
                  </span>
                  <span class="taskDate"
                    >{{
                      task.date_to ? formattedDateWithoutTime(task.date_to) : ""
                    }}
                  </span>
                  <span class="taskAuthor" v-if="task.associated_user">{{
                    task.associated_user.phone ? task.associated_user.phone : ""
                  }}</span>
                </div>
              </draggable>
            </div>
            <!-- IN PROGRESS -->
            <div class="inprogressTasks todoContainer">
              <p class="type">
                W trakcie ({{
                  this.inprogressTasks.total ? this.inprogressTasks.total : 0
                }})
              </p>
              <div class="pagination">
                <i
                  @click="
                    previousPage(
                      inprogressTasks.page_number,
                      inprogressTasks.on_page,
                      'fetchInprogressTasks'
                    )
                  "
                  v-if="this.inprogressTasks.page_number > 1"
                  class="fas fa-arrow-circle-left"
                ></i>
                <i v-else class="fas fa-arrow-circle-left disabled-icon"></i>

                <i
                  @click="
                    nextPage(
                      inprogressTasks.page_number,
                      inprogressTasks.on_page,
                      'fetchInprogressTasks'
                    )
                  "
                  v-if="
                    calcPage(
                      this.inprogressTasks.page_number,
                      this.inprogressTasks.on_page,
                      this.inprogressTasks.total
                    )
                  "
                  class="fas fa-arrow-circle-right"
                ></i>
                <i v-else class="fas fa-arrow-circle-right disabled-icon"></i>
              </div>
              <draggable
                style="height: 90%; overflow: auto"
                v-model="inprogressTasksArray"
                group="tasks"
                @start="drag = true"
                @end="drag = false"
                @change="saveInprogressTasks('IN_PROGRESS')"
              >
                <div
                  class="task"
                  v-for="task in inprogressTasksArray"
                  :key="task.id"
                  data-toggle="modal"
                  :data-target="`#task`"
                  @click="setTask(task)"
                >
                  <!-- <span class="initialCircle">
                    {{ task.associated_user.first_name }}
                  </span> -->
                  <div class="taskTitle">{{ task.title }}</div>
                  <div class="taskPriority">
                    {{
                      task.priority && task.priority === "ONE"
                        ? "Priorytet najwyższy"
                        : ""
                    }}
                  </div>
                  <div class="taskPriority">
                    {{
                      task.priority && task.priority === "TWO"
                        ? "Priorytet wysoki"
                        : ""
                    }}
                  </div>
                  <div class="taskPriority">
                    {{
                      task.priority && task.priority === "THREE"
                        ? "Priorytet niski"
                        : ""
                    }}
                  </div>
                  <div class="taskPriority">
                    {{
                      task.priority && task.priority === "FOUR"
                        ? "Priorytet najniższy"
                        : ""
                    }}
                  </div>
                  <span class="taskCategory">
                    <span v-if="task.messages.length > 0">
                      <span
                        v-if="task.category === 'STEALING'"
                        style="margin-right: 5px"
                        >Kradzież</span
                      >
                      <span
                        v-if="task.category === 'DEATH'"
                        style="margin-right: 5px"
                        >Śmierć</span
                      >
                      <span
                        v-if="task.category === 'PAYMENT'"
                        style="margin-right: 5px"
                        >Płatność</span
                      >
                      <span
                        v-if="task.category === 'RODO'"
                        style="margin-right: 5px"
                        >Rodo</span
                      >
                      <span
                        v-if="task.category === 'PROFILE'"
                        style="margin-right: 5px"
                        >Profil</span
                      >
                      <span
                        v-if="task.category === 'SERVICE'"
                        style="margin-right: 5px"
                        >Usługa</span
                      >
                      <span
                        v-if="task.category === 'VERIFICATION'"
                        style="margin-right: 5px"
                        >Weryfikacja</span
                      >
                      <span
                        v-if="task.category === 'DELETED_ACCOUNT'"
                        style="margin-right: 5px"
                        >Usunięcie konta</span
                      >
                      <i
                        class="far fa-comment"
                        :class="{ unreadMessage: task.last_message_unread }"
                      ></i
                      >{{ task.messages.length }}</span
                    >
                  </span>
                  <span class="taskDate"
                    >{{
                      task.date_to ? formattedDateWithoutTime(task.date_to) : ""
                    }}
                  </span>
                  <span class="taskAuthor" v-if="task.associated_user">{{
                    task.associated_user.phone ? task.associated_user.phone : ""
                  }}</span>
                </div>
              </draggable>
            </div>
          </div>
        </div>
        <!-- tutaj -->
        <div v-if="type === 'finished'">
          <div class="tasksList">
            <!-- SmallTasks -->
            <div class="smallTasks" style="overflow: auto; height: 90%">
              <p class="type">
                Zakończone ({{ doneTasks.total ? doneTasks.total : 0 }})
              </p>
              <div class="pagination">
                <i
                  @click="
                    previousPage(
                      doneTasks.page_number,
                      doneTasks.on_page,
                      'fetchDoneTasks'
                    )
                  "
                  v-if="doneTasks.page_number > 1"
                  class="fas fa-arrow-circle-left"
                ></i>
                <i v-else class="fas fa-arrow-circle-left disabled-icon"></i>

                <i
                  @click="
                    nextPage(
                      doneTasks.page_number,
                      doneTasks.on_page,
                      'fetchDoneTasks'
                    )
                  "
                  v-if="
                    calcPage(
                      doneTasks.page_number,
                      doneTasks.on_page,
                      doneTasks.total
                    )
                  "
                  class="fas fa-arrow-circle-right"
                ></i>
                <i v-else class="fas fa-arrow-circle-right disabled-icon"></i>
              </div>
              <div
                class="smallTask"
                v-for="task in doneTasks.admin_tasks"
                :key="task.id"
                data-toggle="modal"
                :data-target="`#task`"
                @click="setTask(task)"
              >
                <div class="taskTitle">{{ task.title }}</div>
                <div class="taskPriority">
                  {{
                    task.priority && task.priority === "ONE"
                      ? "Priorytet najwyższy"
                      : ""
                  }}
                </div>
                <div class="taskPriority">
                  {{
                    task.priority && task.priority === "TWO"
                      ? "Priorytet wysoki"
                      : ""
                  }}
                </div>
                <div class="taskPriority">
                  {{
                    task.priority && task.priority === "THREE"
                      ? "Priorytet niski"
                      : ""
                  }}
                </div>
                <div class="taskPriority">
                  {{
                    task.priority && task.priority === "FOUR"
                      ? "Priorytet najniższy"
                      : ""
                  }}
                </div>
                <span class="taskCategory">
                  <span v-if="task.messages.length > 0">
                    <span
                      v-if="task.category === 'STEALING'"
                      style="margin-right: 5px"
                      >Kradzież</span
                    >
                    <span
                      v-if="task.category === 'DEATH'"
                      style="margin-right: 5px"
                      >Śmierć</span
                    >
                    <span
                      v-if="task.category === 'PAYMENT'"
                      style="margin-right: 5px"
                      >Płatność</span
                    >
                    <span
                      v-if="task.category === 'RODO'"
                      style="margin-right: 5px"
                      >Rodo</span
                    >
                    <span
                      v-if="task.category === 'PROFILE'"
                      style="margin-right: 5px"
                      >Profil</span
                    >
                    <span
                      v-if="task.category === 'SERVICE'"
                      style="margin-right: 5px"
                      >Usługa</span
                    >
                    <span
                      v-if="task.category === 'VERIFICATION'"
                      style="margin-right: 5px"
                      >Weryfikacja</span
                    >
                    <span
                      v-if="task.category === 'DELETED_ACCOUNT'"
                      style="margin-right: 5px"
                      >Usunięcie konta</span
                    >
                    <i
                      class="far fa-comment"
                      :class="{ unreadMessage: task.last_message_unread }"
                    ></i
                    >{{ task.messages.length }}</span
                  >
                </span>
                <span class="taskDate"
                  >{{
                    task.date_to ? formattedDateWithoutTime(task.date_to) : ""
                  }}
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- NEW TASK MODAL -->
      <div
        class="modal fade"
        id="addNewTask"
        tabindex="-1"
        role="dialog"
        aria-labelledby="addNewTask"
        aria-hidden="true"
      >
        <div class="modal-dialog modal-xl" role="document">
          <div class="modal-content">
            <div class="modal-header">
              <h5 class="modal-title" id="addNewTask">
                Dodawanie nowego zadania
              </h5>
              <button
                type="button"
                class="close"
                data-dismiss="modal"
                aria-label="Close"
              >
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            <div class="modal-body">
              <form class="addNewTaskForm" @submit.prevent="addNewAdminTask()">
                <div class="input-container">
                  <select v-model="taskCategory" class="form-control">
                    <option value="" selected disabled>Kategoria</option>
                    <option
                      :value="category"
                      v-for="category in this.taskCategories"
                      :key="category"
                    >
                      <span v-if="category === 'PROFILE'">Profil</span>
                      <span v-if="category === 'SERVICE'">Usługa</span>
                      <span v-if="category === 'PAYMENT'">Płatność</span>
                      <span v-if="category === 'DEATH'">Śmierć</span>
                      <span v-if="category === 'STEALING'">Kradzień konta</span>
                      <span v-if="category === 'DELETED_ACCOUNT'"
                        >Usunięcie konta</span
                      >
                      <span v-if="category === 'RODO'">Rodo</span>
                      <span v-if="category === 'VERIFICATION'"
                        >Weryfikacja</span
                      >
                    </option>
                  </select>
                </div>
                <div class="input-container">
                  <input
                    v-model="title"
                    id="title"
                    class="form-control"
                    type="text"
                    required
                    minlength="1"
                    maxlength="255"
                    placeholder="Tytuł"
                  />
                </div>
                <div class="input-container">
                  <textarea
                    v-model="message"
                    id="message"
                    class="form-control"
                    type="text"
                    required
                    minlength="1"
                    maxlength="4092"
                    placeholder="Wiadomość..."
                  />
                </div>

                <select v-model="contactType" class="form-control">
                  <option value="" selected disabled>Sposób konktaktu</option>
                  <option
                    :value="contactType"
                    v-for="contactType in this.contactTypes"
                    :key="contactType"
                  >
                    <span v-if="contactType === 'PHONE'">Telefon odebrany</span>
                    <span v-if="contactType === 'PHONE_OUT'"
                      >Telefon wykonany</span
                    >
                    <span v-if="contactType === 'EMAIL'">Email</span>
                    <span v-if="contactType === 'CHAT'">Czat</span>
                    <span v-if="contactType === 'LIST'">List</span>
                  </option>
                </select>
                <label>
                  <input
                    type="file"
                    @change="getImage($event)"
                    id="file-input"
                  />
                </label>

                <div class="input-container">
                  <select v-model="taskPriority" class="form-control">
                    <option value="ONE" selected disabled>Priorytet</option>
                    <option
                      :value="priority"
                      v-for="priority in this.taskPriorities"
                      :key="priority"
                    >
                      <span v-if="priority === 'ONE'">Priorytet najwyższy</span>
                      <span v-if="priority === 'TWO'">Priorytet wysoki</span>
                      <span v-if="priority === 'THREE'">Priorytet niski</span>
                      <span v-if="priority === 'FOUR'"
                        >Priorytet najniższy</span
                      >
                    </option>
                  </select>
                </div>
                <div class="input-container">
                  <input
                    v-model="userPhone"
                    id="title"
                    class="form-control"
                    type="text"
                    required
                    minlength="1"
                    maxlength="255"
                    placeholder="Numer telefonu użytkownika"
                  />
                </div>
                <div class="datepickers">
                  <datepicker
                    :monday-first="true"
                    :language="pl"
                    v-model="date_to"
                    name="taskDateTo"
                    :placeholder="'Termin wykonania zadania'"
                  ></datepicker>
                </div>
                <button class="buttonm btn btn-outline-dark" type="submit">
                  Zapisz
                </button>
              </form>
            </div>

            <div class="modal-footer">
              <button
                type="button"
                class="btn btn-outline-dark"
                data-dismiss="modal"
              >
                Zamknij
              </button>
            </div>
          </div>
        </div>
      </div>

      <!-- OPEN TASK MODAL -->
      <div
        v-if="this.selectedTask"
        class="modal fade"
        :id="`task`"
        tabindex="-1"
        role="dialog"
        aria-labelledby="task"
        aria-hidden="true"
      >
        <div class="modal-dialog modal-xl" role="document">
          <div class="modal-content">
            <div class="modal-header">
              <h5 class="modal-title" :id="`task`">
                Status zadania:
                <span v-if="this.selectedTask.status === 'TODO'">
                  Do zrobienia</span
                >
                <span v-if="this.selectedTask.status === 'IN_PROGRESS'">
                  W trakcie realizcji</span
                >
                <span v-if="this.selectedTask.status === 'DONE'">
                  Zakończone</span
                >

                <div class="datepickers">
                  <datepicker
                    :monday-first="true"
                    :language="pl"
                    v-model="date_to"
                    name="taskDateTo"
                    :placeholder="'Termin wykonania zadania'"
                  ></datepicker>
                  <button
                    @click="changeDateToForTask(selectedTask.id)"
                    class="btn btn-sm btn-outline-dark"
                  >
                    Zapisz
                  </button>
                </div>

                <span
                  v-if="
                    (this.selectedTask.profile_note_user &&
                      this.selectedTask.profile_note_user.phone) ||
                      this.selectedTask.associated_user_phone_number
                  "
                >
                  Dotyczy użytkownika o numerze
                  {{
                    this.selectedTask.profile_note_user &&
                    this.selectedTask.profile_note_user.phone
                      ? this.selectedTask.profile_note_user.phone
                      : this.selectedTask.associated_user_phone_number
                  }}
                </span>
              </h5>
              <button
                type="button"
                class="close"
                data-dismiss="modal"
                aria-label="Close"
                id="closeTaskPreviewButton"
              >
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            <div class="modal-body taskModal" v-if="this.selectedTask">
              <!-- MESSAGES -->
              <div>
                <h6>{{ this.selectedTask.title }}</h6>
              </div>
              <div>
                Osoba zgłaszająca:
                {{ this.selectedTask.admin_user.phone }}
              </div>

              <button
                type="button"
                v-if="this.selectedTask.status !== 'DONE'"
                class="btn btn-outline-dark btn-sm finishTask"
                @click="changeTaskStatus(selectedTask.id, 'DONE')"
              >
                Oznacz zadanie jako wykonane
              </button>

              <button
                type="button"
                v-if="this.selectedTask.status === 'DONE'"
                class="btn btn-outline-dark btn-sm finishTask"
                @click="changeTaskStatus(selectedTask.id, 'TODO')"
              >
                Oznacz jako zadanie do wykonania
              </button>

              <div>
                Przypisana osoba do zadania:
                <select
                  v-model="selectedAdmin"
                  @change="changeAdminForTask(selectedTask.id)"
                >
                  <option :value="selectedAdmin" selected>
                    {{ selectedAdmin }}
                  </option>
                  <option
                    :value="admin.phone"
                    v-for="admin in allAdmins"
                    :key="admin.id"
                  >
                    {{ admin.phone }}
                  </option>
                </select>
              </div>
              <div
                v-for="message in this.selectedTask.messages"
                :key="message.id"
                :size="selectedTaskMessages.length"
              >
                <div
                  class="messageContent"
                  v-if="message.message || message.file_path"
                >
                  <div>
                    <p>{{ formattedDate(message.creationDate) }}</p>
                    <p
                      v-if="
                        message.author_profile &&
                          message.author_profile.first_name !== null
                      "
                    >
                      <b
                        >{{ message.author_profile.first_name }} ({{
                          message.author.phone
                        }})</b
                      >
                    </p>
                  </div>
                  <div class="messageText">
                    {{ message.message }}
                  </div>
                  <div class="messageAttachment" v-if="message.file_path">
                    <span v-if="message.file_type === 'ATTACHMENT'">
                      <button
                        class="
                          taskMessageAttachment
                          btn btn-sm btn-outline-dark
                        "
                        @click="getFile(message.file_path, message.id)"
                      >
                        Załącznik do pobrania
                      </button>
                    </span>
                    <span v-if="message.file_type === 'IMAGE'">
                      <a target="_blank" :href="message.file_path">
                        <img :src="message.file_path" />
                      </a>
                    </span>
                  </div>

                  <i
                    @click="removeTaskMessage(message.id)"
                    class="fas fa-times trashIcon"
                  ></i>
                </div>
              </div>

              <form
                class="addNewTaskMessageForm"
                @submit.prevent="addNewTaskMessage()"
              >
                <div class="input-container" style="width: 100%">
                  <textarea
                    v-model="newTaskMessage"
                    id="title"
                    class="form-control newMessageTextarea"
                    type="text"
                    minlength="1"
                    placeholder="Nowa wiadomość"
                  />

                  <input
                    type="file"
                    @change="getImage($event)"
                    id="message-file-input"
                  />
                </div>
                <button
                  class="buttonm btn btn-outline-dark btn-sm sendMessageButton"
                  type="submit"
                >
                  Dodaj komentarz
                </button>
              </form>
            </div>
            <div class="modal-footer">
              <button
                type="button"
                class="btn btn-outline-dark btn-sm"
                data-dismiss="modal"
              >
                Zamknij
              </button>
            </div>
          </div>
        </div>
      </div>
      <!-- ADD NEW TASK -->
      <div
        class="modal fade"
        id="addNewTask"
        tabindex="-1"
        role="dialog"
        aria-labelledby="addNewTask"
        aria-hidden="true"
      >
        <div class="modal-dialog modal-xl" role="document">
          <div class="modal-content">
            <div class="modal-header">
              <h5 class="modal-title" id="addNewTask">
                Dodawanie nowego zadania
              </h5>
              <button
                type="button"
                class="close"
                data-dismiss="modal"
                aria-label="Close"
              >
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            <div class="modal-body">
              <form class="addNewTaskForm" @submit.prevent="addNewTask()">
                <div class="input-container">
                  <select v-model="taskCategory" class="form-control">
                    <option value="" selected disabled>Kategoria</option>
                    <option
                      :value="category"
                      v-for="category in this.taskCategories"
                      :key="category"
                    >
                      <span v-if="category === 'PROFILE'">Profil</span>
                      <span v-if="category === 'SERVICE'">Usługa</span>
                      <span v-if="category === 'PAYMENT'">Płatność</span>
                      <span v-if="category === 'DEATH'">Śmierć</span>
                      <span v-if="category === 'STEALING'">Kradzień konta</span>
                      <span v-if="category === 'DELETED_ACCOUNT'"
                        >Usunięcie konta</span
                      >
                      <span v-if="category === 'RODO'">Rodo</span>
                      <span v-if="category === 'VERIFICATION'"
                        >Weryfikacja</span
                      >
                    </option>
                  </select>
                </div>
                <div class="input-container">
                  <input
                    v-model="title"
                    id="title"
                    class="form-control"
                    type="text"
                    required
                    minlength="1"
                    maxlength="255"
                    placeholder="Tytuł"
                  />
                </div>

                <div class="input-container">
                  <textarea
                    v-model="message"
                    id="message"
                    class="form-control"
                    type="text"
                    required
                    minlength="1"
                    maxlength="1024"
                    placeholder="Wiadomość..."
                  />
                </div>
                <div class="input-container">
                  <input
                    v-model="userPhone"
                    id="userPhone"
                    class="form-control"
                    type="text"
                    minlength="1"
                    placeholder="Numer telefonu użytkownika"
                  />
                </div>
                <select v-model="contactType" class="form-control">
                  <option value="" selected disabled>Sposób konktaktu</option>
                  <option
                    :value="contactType"
                    v-for="contactType in this.contactTypes"
                    :key="contactType"
                  >
                    <span v-if="contactType === 'PHONE'">Telefon odebrany</span>
                    <span v-if="contactType === 'PHONE_OUT'"
                      >Telefon wykonany</span
                    >
                    <span v-if="contactType === 'EMAIL'">Email</span>
                    <span v-if="contactType === 'CHAT'">Czat</span>
                    <span v-if="contactType === 'LIST'">List</span>
                  </option>
                </select>

                <label>
                  <input
                    type="file"
                    @change="getImage($event)"
                    id="file-input"
                  />
                </label>
                <button class="buttonm btn btn-outline-dark" type="submit">
                  Zapisz
                </button>
              </form>
            </div>

            <div class="modal-footer">
              <button
                type="button"
                class="btn btn-outline-dark"
                data-dismiss="modal"
              >
                Zamknij
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import draggable from "vuedraggable";
import shared from "../shared";
import Datepicker from "vuejs-datepicker";
import { pl } from "vuejs-datepicker/dist/locale";
//import Pagination from "../components/Pagination";
//import ManagementPanel from "../components/ManagementPanel";
import axios from "../axios";
import { tasksNavigationOptions } from "@/utils/options.js";
import UserProcessNav from "../components/UserProcessNav.vue";
export default {
  name: "Tasks",
  //components: { ManagementPanel, Pagination },
  components: {
    draggable,
    Datepicker,
    UserProcessNav,
  },
  data() {
    return {
      pl: pl,
      type: "active",
      title: "",
      userPhone: "",
      message: "",
      newTaskMessage: "",
      taskId: "",
      taskCategories: [],
      contactTypes: [],
      contactType: "",
      taskCategory: "",
      allShowed: true,
      file: null,
      inprogressTasksArray: [],
      todoTasksArray: [],
      selectedAdmin: null,
      selectedTaskMessages: [],
      admins: [],
      taskPriorities: [],
      date_to: null,
      taskPriority: "ONE",
      filter_param: "",
      tasksNavigationOptions: tasksNavigationOptions,
      selectedDate: "Nadchodzące",
      //filters
      own: false,
      priority: null,
      category: null,
      status: false,
      today: false,
      future: true,
      old: false,
      loading: false,
      selectedTask: null,
      selectedAssignedAdmin: {
        id: "Brak",
        phone: "Brak",
      },
    };
  },

  async mounted() {
    this.loading = true;
    await this.$store.dispatch("fetchProcesTypes");
    await this.$store.dispatch("fetchAllAdmins");
    Object.filter = (obj, predicate) =>
      Object.keys(obj)
        .filter((key) => predicate(obj[key]))
        .reduce((res, key) => ((res[key] = obj[key]), res), {});

    this.inprogressTasksArray = [];
    this.todoTasksArray = [];
    this.formattedDate = shared.formattedDateAsNumbers;
    this.formattedDateWithoutTime = shared.formattedDateWithoutTime;
    this.isToday = shared.isToday;
    this.isFuture = shared.isFuture;
    this.fetchAll();

    await axios.get(`/api/adminTask/categories`).then((response) => {
      this.taskCategories = response.data;
    });

    await axios.get(`/api/adminTask/priorities`).then((response) => {
      this.taskPriorities = response.data;
    });

    await axios.get(`/api/profileNote/contactTypes`).then((response) => {
      this.contactTypes = response.data;
    });

    setTimeout(() => {
      this.todoTasksArray = this.todoTasks.admin_tasks
        ? this.todoTasks.admin_tasks
        : [];
      this.inprogressTasksArray = this.inprogressTasks.admin_tasks
        ? this.inprogressTasks.admin_tasks
        : [];
      this.loading = false;
    }, 1500);
  },
  methods: {
    showTaskAssignedToAdmin(e) {
      const selectedAdminPhone = e.target.value;
      if (selectedAdminPhone && selectedAdminPhone !== "Brak") {
        const selectedAdmin = this.allAdmins.find(
          (a) => a.phone === selectedAdminPhone
        );
        this.selectedAssignedAdmin = {
          id: selectedAdmin.id,
          phone: selectedAdmin.phone,
        };
        this.own = false;
        this.fetchAll();
      } else {
        this.selectedAssignedAdmin = {
          id: "Brak",
          phone: "Brak",
        };
        this.showAllTasks();
      }
    },

    showConvertedString(type) {
      if (type === "CUSTOMER_SUCCESS") return "Customer Success";
      if (type === "REJECTED_BY_ADMIN") return "Odrzucone przez admina";
      if (type === "WITHOUT_VERIFICATION_PAYMENT")
        return "Niedokończona/nierozpoczęta płatność";
      else return "";
    },
    searchWithParam() {
      this.fetchAll();
    },
    calcPage(pageNumber, onPage, total) {
      const page_number = pageNumber;
      const total_value = total;
      const on_page = onPage;

      if (total_value / on_page > page_number) {
        return true;
      } else {
        return false;
      }
    },
    nextPage(pageNumber, onPage, dispatchAction) {
      this.loading = true;
      this.$store
        .dispatch(dispatchAction, {
          on_page: onPage,
          page_number: pageNumber + 1,
          own: this.own,
          status: this.status,
          category: this.category,
          priority: this.priority,
          today: this.today,
        })
        .then(() => {
          this.todoTasksArray = this.todoTasks.admin_tasks
            ? this.todoTasks.admin_tasks
            : [];
          this.inprogressTasksArray = this.inprogressTasks.admin_tasks
            ? this.inprogressTasks.admin_tasks
            : [];
          this.loading = false;
        });
    },
    previousPage(pageNumber, onPage, dispatchAction) {
      this.loading = true;
      this.$store
        .dispatch(dispatchAction, {
          on_page: onPage,
          page_number: pageNumber - 1,
          own: this.own,
          status: this.status,
          category: this.category,
          priority: this.priority,
          today: this.today,
        })
        .then(() => {
          this.todoTasksArray = this.todoTasks.admin_tasks
            ? this.todoTasks.admin_tasks
            : [];
          this.inprogressTasksArray = this.inprogressTasks.admin_tasks
            ? this.inprogressTasks.admin_tasks
            : [];
          this.loading = false;
        });
    },
    redirectToUserProcess(process) {
      console.log(process);
      if (process === "WITHOUT_VERIFICATION_PAYMENT")
        this.$router.push({
          name: "UserProcess",
          params: { type: "WITHOUT_VERIFICATION_PAYMENT" },
        });
    },

    changeAdminForTask(taskId) {
      const url = `/api/adminTask/${taskId}/associated_admin?associated_user=${this.selectedAdmin}`;
      axios
        .put(url)
        .then(() => {
          this.fetchAll();
        })
        .catch((err) => {
          console.log(err);
        });
    },
    setTask(task) {
      this.selectedTask = task;
      this.selectedAdmin =
        task.associated_user && task.associated_user.phone
          ? task.associated_user.phone
          : null;
      this.selectedTaskMessages = task.messages;
      this.date_to = new Date(task.date_to);
      axios.put(`/api/adminTask/${task.id}/messageRead`).then(() => {
        this.fetchAll();
      });
    },

    changeDateToForTask(taskId) {
      const body = new FormData();
      const config = {
        headers: {
          Accept: "application/json",
          "Content-Type": "multipart/form-data",
        },
      };
      body.append("date_to", this.date_to);
      const url = `/api/adminTask/${taskId}/date_to`;
      axios
        .put(url, body, config)
        .then(() => {
          this.fetchAll();
        })
        .catch((err) => {
          console.log(err);
        });
    },
    fetchAll() {
      this.loading = true;
      this.fetchData("fetchTodoTasks").then(() => {
        setTimeout(() => {
          this.todoTasksArray = this.todoTasks.admin_tasks
            ? this.todoTasks.admin_tasks
            : [];
        }, 2000);
      });
      this.loading = true;
      this.fetchData("fetchInprogressTasks").then(() => {
        this.loading = false;
        setTimeout(() => {
          this.inprogressTasksArray = this.inprogressTasks.admin_tasks
            ? this.inprogressTasks.admin_tasks
            : [];
        }, 2000);
      });

      this.fetchData("fetchDoneTasks");
    },

    fetchData(fetchAction) {
      return this.$store.dispatch(fetchAction, {
        own: this.own,
        status: this.status,
        category: this.category,
        priority: this.priority,
        today: this.today,
        future: this.future,
        old: this.old,
        filter_param: this.filter_param,
        admin_id:
          this.selectedAssignedAdmin &&
          this.selectedAssignedAdmin.id &&
          this.selectedAssignedAdmin.id !== "Brak"
            ? this.selectedAssignedAdmin.id
            : null,
      });
    },
    showAllTasks() {
      this.selectedAssignedAdmin = {
        id: "Brak",
        phone: "Brak",
      };
      this.own = false;
      this.fetchAll();
    },
    showOwnTasks() {
      this.selectedAssignedAdmin = {
        id: "Brak",
        phone: "Brak",
      };
      this.own = true;
      this.fetchAll();
    },
    async showTodayTasks() {
      this.selectedDate = "Dzisiejsze";
      this.loading = true;
      this.type = "active";
      this.today = true;
      this.future = false;
      this.old = false;
      this.fetchAll();
    },
    showOldTasks() {
      this.selectedDate = "Przeterminowane";
      this.loading = true;
      this.type = "active";
      this.today = false;
      this.future = false;
      this.old = true;
      this.fetchAll();
    },
    showFutureTasks() {
      this.selectedDate = "Nadchodzące";
      this.loading = true;
      this.type = "active";
      this.today = false;
      this.future = true;
      this.old = false;
      this.fetchAll();
    },
    showFinishedTasks() {
      this.selectedDate = "Zakończone";
      this.type = "finished";
      this.today = false;
      this.future = false;
      this.old = false;
      this.fetchData("fetchDoneTasks");
    },
    showPriorityOne() {
      this.priority = "ONE";
      this.fetchAll();
    },
    showPriorityTwo() {
      this.priority = "TWO";
      this.fetchAll();
    },
    showPriorityThree() {
      this.priority = "THREE";
      this.fetchAll();
    },
    showPriorityFour() {
      this.priority = "FOUR";
      this.fetchAll();
    },
    showAllPriorities() {
      this.priority = null;
      this.fetchAll();
    },
    showVerificationTasks() {
      this.category = "VERIFICATION";
      this.fetchAll();
    },
    showRodoTasks() {
      this.category = "RODO";
      this.fetchAll();
    },
    showDeathTasks() {
      this.category = "DEATH";
      this.fetchAll();
    },
    showProfileTasks() {
      this.category = "PROFILE";
      this.fetchAll();
    },
    showServiceTasks() {
      this.category = "SERVICE";
      this.fetchAll();
    },
    showPaymentTasks() {
      this.category = "PAYMENT";
      this.fetchAll();
    },
    showStolenAccountTasks() {
      this.category = "STEALING";
      this.fetchAll();
    },
    showDeletedAccountTasks() {
      this.category = "DELETED_ACCOUNT";
      this.fetchAll();
    },
    showAllCategories() {
      (this.category = null), this.fetchAll();
    },

    saveTodoTasks(status) {
      const url = `/api/adminTask/status?status=${status}`;
      const body = {
        tasks: this.todoTasksArray,
      };
      axios
        .put(url, body)
        .then(() => {
          this.fetchAll();
        })
        .catch((err) => {
          console.log(err);
        });
    },

    saveInprogressTasks(status) {
      const url = `/api/adminTask/status?status=${status}`;
      const body = {
        tasks: this.inprogressTasksArray,
      };
      axios
        .put(url, body)
        .then(() => {
          this.fetchAll();
        })
        .catch((err) => {
          console.log(err);
        });
    },

    async getFile(id, messageId) {
      axios({
        url: id,
        method: "GET",
        responseType: "blob",
      }).then((response) => {
        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute("download", messageId + "." + id.split(".").pop());
        document.body.appendChild(link);
        link.click();
      });
    },

    getImage(e) {
      e.preventDefault();
      this.file = e.target.files[0];
    },

    fetchTodoTasks() {
      this.$store.dispatch("fetchTodoTasks", {
        on_page: this.tasks.on_page,
        page_number: this.tasks.page_number,
        search_param: this.searchParams,
        filter_param: "DONE",
        second_filter_param: this.secondFilterParam,
      });
    },
    showOwn() {
      this.allShowed = false;
      this.fetchTodoTasks();
    },
    showAll() {
      this.allShowed = true;
      this.fetchTodoTasks();
    },

    addNewTaskMessage() {
      if (!this.newTaskMessage && !this.file) {
        return this.$notify({
          group: "error",
          text:
            "Wiadomośc nie może być pusta. Musi zawierać teks lub załącznik",
        });
      }
      const url = `/api/adminTaskMessage/${this.selectedTask.id}`;

      const body = new FormData();
      body.append("message", this.newTaskMessage);
      body.append("file", this.file);

      const config = {
        headers: {
          Accept: "application/json",
          "Content-Type": "multipart/form-data",
        },
      };
      axios
        .post(url, body, config)
        .then((response) => {
          if (response.status === 200) {
            this.selectedTaskMessages.push(response.data);
            this.$notify({
              group: "success",
              text: "Pomyślnie dodano wiadomość",
            });

            this.fetchAll();
            this.newTaskMessage = "";
          }
          (this.newTaskMessage = ""), (this.file = null);
        })
        .catch((err) => {
          console.log(err);
          this.$notify({
            group: "error",
            text: "Nie udało się dodać wiadomości",
          });
        });
    },

    //REMOVE TASK MESSAGE
    removeTaskMessage(messageId) {
      const url = `/api/adminTaskMessage/${messageId}`;
      axios
        .delete(url)
        .then((response) => {
          this.selectedTaskMessages.forEach((message) => {
            if (message.id === messageId) {
              this.selectedTaskMessages.splice(
                this.selectedTaskMessages.indexOf(message),
                1
              );
              this.$notify({
                group: "success",
                text: "Pomyślnie usunięto wiadomość",
              });
            }
          });
          this.selectedTaskMessages.push(response.data);
          this.fetchAll();
        })
        .catch((err) => {
          console.log(err);
          this.$notify({
            group: "error",
            text: "Nie udało się usunąć wiadomości",
          });
        });
    },

    //ADD NEW TASK
    addNewAdminTask() {
      const url = `/api/adminTask`;
      if (this.taskCategory === "") {
        return this.$notify({
          group: "error",
          text: "Wybierz kategorię",
        });
      }
      const isCorrectDate =
        this.isToday(this.date_to) || this.isFuture(this.date_to);
      if (!isCorrectDate) {
        return this.$notify({
          group: "error",
          text: "Podano niepoprawny termin wykonania zadania",
        });
      }

      const body = new FormData();
      body.append("message", this.message);
      body.append("title", this.title);
      body.append("category", this.taskCategory);
      body.append("file", this.file);
      //body.append("associated_user", this.userPhone);
      body.append("contact_type", this.contactType);
      //body.append("is_important", this.is_important);
      body.append("date_to", this.date_to);
      //body.append("user_id", this.$route.params.id);
      body.append("associated_user_phone_number", this.userPhone);
      body.append("priority", this.taskPriority);

      const config = {
        headers: {
          Accept: "application/json",
          "Content-Type": "multipart/form-data",
        },
      };
      axios
        .put(url, body, config)
        .then((response) => {
          if (response.status === 200) {
            this.$notify({
              group: "success",
              text: "Pomyślnie dodano zadanie",
            });
            (this.title = ""),
              (this.message = ""),
              (this.taskCategory = ""),
              (this.userPhone = ""),
              (this.contactType = "");
            this.category = "";
            this.file = null;
          }
          this.fetchAll();
        })
        .catch((err) => {
          console.log(err.response.data);
          if (
            err.response.data.message ===
            "Not found user with this phone number"
          ) {
            this.$notify({
              group: "error",
              text: "Nie istnieje użytkownik o takim numerze",
            });
          }
        });
    },

    addNewTask() {
      const url = `/api/adminTask`;
      if (this.taskCategory === "") {
        this.$notify({
          group: "error",
          text: "Wybierz kategorię",
        });
      }

      const body = new FormData();
      body.append("message", this.message);
      body.append("title", this.title);
      body.append("category", this.taskCategory);
      body.append("file", this.file);
      body.append("associated_user", this.userPhone);
      body.append("contact_type", this.contactType);

      const config = {
        headers: {
          Accept: "application/json",
          "Content-Type": "multipart/form-data",
        },
      };
      axios
        .post(url, body, config)

        .then((response) => {
          if (response.status === 200) {
            this.$notify({
              group: "success",
              text: "Pomyślnie dodano zadanie",
            });
            this.fetchTodoTasks()((this.title = "")),
              (this.message = ""),
              (this.taskCategory = ""),
              (this.userPhone = ""),
              (this.contactType = "");
            this.category = "";
            this.file = null;
          }
        })
        .catch((err) => {
          console.log(err.response.data);
          if (
            err.response.data.message ===
            "Not found user with this phone number"
          ) {
            this.$notify({
              group: "error",
              text: "Nie istnieje użytkownik o takim numerze",
            });
          }
        });
    },

    changeTaskStatus(taskId, status) {
      const url = `/api/adminTask/${taskId}?status=${status}`;
      axios
        .post(url)
        .then(() => {
          this.fetchAll();
          this.$notify({
            group: "success",
            text: "Pomyślnie zakończono zadanie",
          });
          const closeButton = document.getElementById("closeTaskPreviewButton");
          closeButton.click();
        })
        .catch((err) => {
          this.$notify({
            group: "success",
            text: "Nie udało się zakończyć zadania",
          });
          console.log(err);
        });
    },
  },

  computed: {
    processTypes() {
      return this.$store.getters.getProcessTypes;
    },
    allAdmins() {
      return this.$store.getters.getAllAdmins;
    },
    inprogressTasks() {
      return this.$store.getters.getInprogressTasks;
    },
    todoTasks() {
      return this.$store.getters.getTodoTasks;
    },
    todayTodoTasks() {
      return this.$store.getters.getTodayTasks;
    },
    ownTasks() {
      return this.$store.getters.getOwnTasks;
    },
    doneTasks() {
      return this.$store.getters.getDoneTasks;
    },
    searchParams() {
      return this.$store.getters.getSearchParameter;
    },
    filterParam() {
      return this.$store.getters.getFilterParameter;
    },
    secondFilterParam() {
      return this.$store.getters.getSecondFilterParameter;
    },
  },
};
</script>

<style scoped>
.left-panel {
  width: 20vw;
  display: flex;
  flex-direction: column;
  align-items: flex-end;
}
.filterButtons button {
  box-shadow: 0px 0px 8px -3px rgba(0, 0, 0, 0.64);
  height: 25px;
  min-width: 100%;
  margin-bottom: 10px;
  border-radius: 5px;
  font-size: 11px;
}

.filterButtons input {
  box-shadow: 0px 0px 8px -3px rgba(0, 0, 0, 0.64);
  height: 25px;
  min-width: 100%;
  margin-bottom: 10px;
  border-radius: 5px;
  font-size: 11px;
  display: flex;
}
.filterButtons {
  display: flex;
  flex-direction: column;
  margin-bottom: 20px;
  width: 100%;
}
.main-content {
  width: 80vw;
}
.tasks {
  display: flex;
  justify-content: flex-start;
  font-size: 11px !important;
}
.todoContainer {
  border: 1px solid rgb(153, 144, 144);
  box-shadow: 0px 0px 10px -3px rgba(0, 0, 0, 0.64);

  border-radius: 4px;
  width: 40%;
  margin: 0 10px 10px 10px;
}
.task {
  border: 1px solid rgb(206, 198, 198);
  box-shadow: 0px 0px 5px -1px rgba(0, 0, 0, 0.64);
  border-radius: 5px;
  min-height: 100px;
  position: relative;
  margin: 5px;
}
.smallTask {
  border: 1px solid rgb(206, 198, 198);
  box-shadow: 0px 0px 5px -1px rgba(0, 0, 0, 0.64);
  border-radius: 5px;
  min-height: 60px;
  position: relative;
  margin: 5px;
}
.smallTaskTitle {
  padding: 0;
  max-height: 50px;
  text-overflow: ellipsis;
  overflow: hidden;
  display: -webkit-box;
  -webkit-line-clamp: 1;
  -webkit-box-orient: vertical;
  padding-right: 30px;
}
.taskTitle {
  padding: 0;
  max-height: 50px;
  text-overflow: ellipsis;
  overflow: hidden;
  display: -webkit-box;
  -webkit-line-clamp: 3;
  -webkit-box-orient: vertical;
  padding-right: 30px;
}
.taskMessage {
}
.taskAuthor {
  position: absolute;
  right: 5px;
  top: 5px;
  font-size: 10px;
  border-radius: 100px;
  background: #d1cdcd;
  padding: 4px;

  height: 20px;
  text-align: center;
  font-weight: bold;
}
.disabled-icon {
  color: rgba(182, 182, 182, 0.571);
}
.datepickers {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
}
.datepickers button {
  width: 165px;
  margin-left: 10px;
}

.menagment-panel i {
  font-size: 30px;
  cursor: pointer;
  margin: 5px;
  transform: translateY(7px);
}
.type {
  font-weight: bold;
  margin-bottom: 20px;
}
.left-addon {
  display: flex;
  align-items: center;
}
.inner-addon {
  position: relative;
}

/* style icon */
.inner-addon .searchIcon {
  position: absolute;
  padding: 10px;
  pointer-events: none;
}

/* align icon */
.left-addon .searchIcon {
  left: 0px;
}
.right-addon .searchIcon {
  right: 0px;
}

/* add padding  */
.left-addon input {
  padding-left: 30px;
}
.right-addon input {
  padding-right: 30px;
}
.taskDate {
  position: absolute;
  bottom: 5px;
  left: 5px;
  font-size: 11px;
}
.unreadMessage {
  color: red;
  font-weight: bold;
}
.titlePlace {
  text-align: center;
}
.taskTitle {
  margin: 0 auto;
  font-weight: bold;
}
.pagination {
  position: absolute;
  right: 10px;
  top: 5px;
}
.pagination i {
  cursor: pointer;
  font-size: 20px;
  margin: 4px;
}

.smallTasks {
  border: 1px solid rgb(153, 144, 144);
  box-shadow: 0px 0px 10px -3px rgba(0, 0, 0, 0.64);
  border-radius: 4px;
  width: 80%;
  margin: 0 10px 10px 10px;
  position: relative;
}
.newMessageTextarea {
  width: 70%;
  margin: 0 auto;
}
.taskPriority {
  font-weight: bold;
  font-size: 9px;
}
.inprogressTasks,
.todoTasks {
  position: relative;
}

.forLater {
}
.sendMessageButton {
  width: 70%;
}

.finishTask {
  position: absolute;
  top: 50px;
  right: 20px;
}
.taskModal {
  position: relative;
}
.selectedButton {
  background: #b3b7bb;
}
.taskPriority {
  position: absolute;
  bottom: 5px;
  right: 5px;
  font-size: 12px;
}
.taskCategory {
  position: absolute;
  bottom: 25px;
  left: 5px;
  font-size: 12px;
}
.tasksList {
  display: flex;
  justify-content: flex-start;
  height: 100vh;
}
.doneIcon,
.todoIcon {
  position: absolute;
  top: 2px;
  font-size: 20px;
  right: 3px;
  cursor: pointer;
}
.taskNoteUser {
  position: absolute;
  bottom: 20px;
  right: 5px;
}
.addNewTaskButton {
  width: 100%;
  text-align: center;
}
.copyIcon {
  position: absolute;
  top: 27%;
  font-size: 20px;
  right: 3px;
  cursor: pointer;
}
.trashIcon {
  position: absolute;
  top: 5px;
  font-size: 15px;
  right: 5px;
  cursor: pointer;
  color: rgb(255, 0, 0);
}
.menagment-panel {
  justify-content: space-around;
}
.collapse,
.card {
  width: 69vw;
}
.messageContent {
  position: relative;
  border: 1px solid rgb(219, 208, 208);
  border-radius: 4px;
}
.addNewTaskForm {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  text-align: center;
}
.addNewTaskMessageForm {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  text-align: center;
  margin-top: 50px;
}
.addNewTaskMessageForm input {
  margin-top: 10px;
}
.addNewTaskMessageForm input {
  margin-top: 10px;
}
.addNewTaskForm input,
.addNewTaskForm textarea,
.addNewTaskForm button,
.addNewTaskForm select {
  width: 400px;
}
.addNewTaskForm textarea,
.addNewTaskMessageForm textarea {
  height: 70px;
  border-radius: 10px;
}

.addNewTaskForm button {
  margin-top: 20px;
}
.userInfo {
  position: absolute;
  bottom: 0;
  right: 3px;
  font-size: 14px;
}

.taskMessageAttachment {
  border-radius: 50px;
}

.yellowButton {
  color: #212529;
  background-color: #ffc107;
  border-color: #ffc107;
  border-radius: 5px;
}

.greyButton {
  color: #fff;
  background-color: #6c757d;
  border-color: #6c757d;
  border-radius: 5px;
}

img {
  max-width: 100%;
  height: auto;
  width: auto;
}

@media screen and (max-width: 1600px) {
  .userInfo {
    position: relative;
  }
}
.title p {
  font-weight: 300;
  cursor: pointer;
}
.title .active {
  font-weight: 600;
}
</style>
